import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Grid, Input, Button} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';


class BackOrdersFilters extends Component {
  componentDidMount() {
    this.props.clearTextFilter();
  }

  onCancelClick() {
    this.props.clearTextFilter();
    this.props.changeBackOrdersListPage(0);
  }

  onBoxFilterChange(event) {
    this.props.changeBoxTextFilter(event.target.value);
  }

  onPartCodeFilterChange(event) {
    this.props.changePartCodeTextFilter(event.target.value);
  }

  onInvoiceQuantityFilterChange(event) {
    this.props.changeInvoiceQuantityTextFilter(event.target.value);
  }

  onInvoiceBackOrdersFilterChange(event) {
    this.props.changeInvoiceBackOrdersTextFilter(event.target.value);
  }

  onNationalBackOrdersFilterChange(event) {
    this.props.changeNationalBackOrdersTextFilter(event.target.value);
  }

  onRequester1FilterChange(event) {
    this.props.changeRequester1TextFilter(event.target.value);
  }

  onRequester2FilterChange(event) {
    this.props.changeRequester2TextFilter(event.target.value);
  }

  onRequester3FilterChange(event) {
    this.props.changeRequester3TextFilter(event.target.value);
  }

  render() {
    const {
      filterBoxText,
      filterPartCodeText,
      filterInvoiceQuantityText,
      filterInvoiceBackOrdersText,
      filterNationalBackOrdersText,
      filterRequester1Text,
      filterRequester2Text,
      filterRequester3Text,
    } = this.props;
    return (
      <Grid columns='equal'>
        <Grid.Row>
          <Grid.Column>
            <Input
              placeholder='Caja'
              value={filterBoxText}
              onChange={this.onBoxFilterChange.bind(this)}
            />
          </Grid.Column>
          <Grid.Column>
            <Input
              placeholder='Item'
              value={filterPartCodeText}
              onChange={this.onPartCodeFilterChange.bind(this)}
            />
          </Grid.Column>
          <Grid.Column>
            <Input
              placeholder='Cantidad F.'
              type='number'
              value={filterInvoiceQuantityText}
              onChange={this.onInvoiceQuantityFilterChange.bind(this)}
            />
          </Grid.Column>
          <Grid.Column>
            <Input
              placeholder='B.O. Factura'
              type='number'
              value={filterInvoiceBackOrdersText}
              onChange={this.onInvoiceBackOrdersFilterChange.bind(this)}
            />
          </Grid.Column>
          <Grid.Column>
            <Input
              placeholder='B.O. Nacional'
              type='number'
              value={filterNationalBackOrdersText}
              onChange={this.onNationalBackOrdersFilterChange.bind(this)}
            />
          </Grid.Column>
          <Grid.Column>
            <Input
              placeholder='Agencia 1'
              value={filterRequester1Text}
              onChange={this.onRequester1FilterChange.bind(this)}
            />
          </Grid.Column>
          <Grid.Column>
            <Input
              placeholder='Agencia 2'
              value={filterRequester2Text}
              onChange={this.onRequester2FilterChange.bind(this)}
            />
          </Grid.Column>
          <Grid.Column>
            <Input
              placeholder='Agencia 3'
              value={filterRequester3Text}
              onChange={this.onRequester3FilterChange.bind(this)}
            />
          </Grid.Column>
          <Grid.Column>
            <Button
              type='button'
              secondary
              className='toyota-secondary'
              onClick={this.onCancelClick.bind(this)}
            >
              Limpiar
            </Button>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'filterBoxText': state.backOrders.filterBoxText,
    'filterPartCodeText': state.backOrders.filterPartCodeText,
    'filterInvoiceQuantityText': state.backOrders.filterInvoiceQuantityText,
    'filterInvoiceBackOrdersText': state.backOrders.filterInvoiceBackOrdersText,
    'filterNationalBackOrdersText': state.backOrders.filterNationalBackOrdersText,
    'filterRequester1Text': state.backOrders.filterRequester1Text,
    'filterRequester2Text': state.backOrders.filterRequester2Text,
    'filterRequester3Text': state.backOrders.filterRequester3Text,
  };
};

const {
  changeBoxTextFilter,
  changePartCodeTextFilter,
  changeInvoiceQuantityTextFilter,
  changeInvoiceBackOrdersTextFilter,
  changeNationalBackOrdersTextFilter,
  changeRequester1TextFilter,
  changeRequester2TextFilter,
  changeRequester3TextFilter,
  changeBackOrdersListPage,
  clearTextFilter,
} = Actions;

export default connect(mapStateToProps, {
  changeBoxTextFilter,
  changePartCodeTextFilter,
  changeInvoiceQuantityTextFilter,
  changeInvoiceBackOrdersTextFilter,
  changeNationalBackOrdersTextFilter,
  changeRequester1TextFilter,
  changeRequester2TextFilter,
  changeRequester3TextFilter,
  changeBackOrdersListPage,
  clearTextFilter,
})(BackOrdersFilters);
